import axios from "axios";
import * as _ from 'lodash';

const consumerActiveOrdersURL = '/api/consumerorder/activeorders?language=';
const consumerOrderHistoryURL = '/api/consumerorder/orderhistory?language=';
const hcpOrderHistoryURL = '/api/hcporder/orderhistory?language=';

const orderHistory = {
	state: () => ({
		activeOrdersData: [],
		orderHistoryData: [],
		showOrderHistorySkeleton: true,
	}),
	getters: {
		getActiveOrdersData: function (state) {
			return state.activeOrdersData;
		},
		getOrderHistoryData: function (state) {
			return state.orderHistoryData;
		},
		getShowOrderHistorySkeleton: (state) => state.showOrderHistorySkeleton,
	},
	mutations: {
		setActiveOrdersData: function (state, data) {
			state.activeOrdersData = data || [];
		},
		setOrderHistoryData: function (state, data) {
			state.orderHistoryData = data || [];
		},
		hideOrderHistorySkeleton: (state) => {
			state.showOrderHistorySkeleton = false;
		}
	},
	actions: {
		getActiveOrders: _.throttle(function ({ commit, rootGetters, state }, isHcpOrders = false) {
			if (!state.showOrderHistorySkeleton) {
				commit('setSpinnerIsShown', true, { root: true });
			}
			const apiUrl = isHcpOrders ? hcpOrderHistoryURL : consumerActiveOrdersURL;
			axios.get(apiUrl + rootGetters['getCulture'])
				.then(response => {
					commit('setActiveOrdersData', response.data.orders);
					commit('setSpinnerIsShown', false, { root: true });
					commit('hideOrderHistorySkeleton');
				})
				.catch(error => {
					commit('setActiveOrdersData', error.response);
					commit('setSpinnerIsShown', false, { root: true });
					commit('hideOrderHistorySkeleton');
				});
		}, 500, { trailing: false }),
		getOrderHistory: function ({ commit, rootGetters, state }, payload) {
			const monthIntervalParameter = Number.isInteger(parseInt(payload.monthInterval)) ? `&MonthInterval=${payload.monthInterval}` : '';
			if (!state.showOrderHistorySkeleton) {
				commit('setSpinnerIsShown', true, { root: true });
			}
			const apiUrl = payload.isHcpOrders ? hcpOrderHistoryURL : consumerOrderHistoryURL;
			axios.get(apiUrl + rootGetters['getCulture'] + monthIntervalParameter)
				.then(response => {
					commit('setOrderHistoryData', response.data.orders);
					commit('setSpinnerIsShown', false, { root: true });
					commit('hideOrderHistorySkeleton');
				})
				.catch(error => {
					commit('setOrderHistoryData', error.response);
					commit('setSpinnerIsShown', false, { root: true });
					commit('hideOrderHistorySkeleton');
				});
		},
	}
};

export default orderHistory;
